import api from '../utils/api';

class RoutesApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/routes', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
  getAllRoutes = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/routes/get-routes', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
  getAllRoutesOperator = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/routes/findAll/groupRoute', {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getListSegmentDDD = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(
          `https://booking.demdikk.sn/3dreserva/api/api-liste-depart.php`,
          { params: data },
        );
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
  getDestinations = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/routes/dest/' + id, { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDestinationsOperator = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/routes/destinations');
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDisabledSeatById = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/pos/routes/seat/disabled', {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/routes', data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };

  createDisabledSeat = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/v1/pos/routes/disabled', data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/routes/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateParams = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/routes/params/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  syncPriceSegmentDDD = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/routes/price/ddd', data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/routes/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  enableSeat = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/v1/pos/routes/enabled`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/routes/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateStatus = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/routes/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  onCreateReturn = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/routes/create-return/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  onCreateDateDDD = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/routes/rates/ddd`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  copy = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/routes/copy/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}
const routesApi = new RoutesApi();
export default routesApi;
